import { HTTP_VERBS, WebExtensibleUtil } from 'app/shared/utils/web-extensible.util';
import { Activity, AzureKeyVaultLinkedService, Metamodel } from 'shell-models-lib';

// NOTE: anredd - No plan on release, retaining this just in case but should be deleted eventually
@Metamodel.model({
    name: 'AzureKeyVaultActivity',
    referable: true,
})
export class AzureKeyVaultActivity extends Activity {
    @Metamodel.attribute({
        display: __IS_FABRIC_DPE__ ? stringResources.ConnectionLabel : stringResources.LinkedService,
        constraint: {
            required: true,
            validator: WebExtensibleUtil.validateConnection
        },
        reference: true,
        type: AzureKeyVaultLinkedService.MODEL
    })
    public akvLinkedService?: AzureKeyVaultLinkedService;

    public method: HTTP_VERBS = 'GET';
    public connector: string = 'akv';

    constructor(name?: string, description?: string) {
        super(name, description);
        this.policy.secureInput = true;
        this.policy.secureOutput = true;
    }
}